import { ColDef, ICellRendererParams } from 'ag-grid-community'
import columnRenderers, { PLACEHOLDER } from 'components/column-renderers'
import { CSVField } from 'hooks/useExportCSV'
import React, { useMemo } from 'react'
import { TeamInfo, TeamInfoMember } from 'types'
import { formatDate } from 'utils'
import { TeamsMembersCell } from '../TeamsMembersCell/TeamsMembersCell'

export function useFamilyCaregiverTeamsPageColumns() {
  const columnDefs: ColDef[] = useMemo(() => {
    return [
      {
        headerName: 'Team ID',
        field: 'id',
      },
      {
        headerName: 'Team Name',
        field: 'name',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Initial Family Caregiver',
        field: 'ownerFirstname',
        minWidth: 220,
        cellRenderer: (
          props: ICellRendererParams<{
            ownerFirstname: string
            ownerLastname: string
          }>,
        ) => {
          if (!props.data) return PLACEHOLDER

          const { ownerFirstname, ownerLastname } = props.data
          return `${ownerFirstname} ${ownerLastname}`
        },
      },
      {
        headerName: 'Team Members',
        field: 'members',
        cellRenderer: (
          props: ICellRendererParams<{
            id: number
            members: TeamInfoMember[]
          }>,
        ) => {
          if (!props.data) return PLACEHOLDER

          const { id, members } = props.data
          if (!members || members.length === 0) return PLACEHOLDER

          return <TeamsMembersCell members={members} teamId={id} readonly />
        },
      },
      {
        headerName: 'Creation Date',
        field: 'createdAt',
        cellRenderer: columnRenderers.createdAt,
      },
      {
        headerName: 'Promo Code',
        field: 'accessCodeCode',
        filter: 'agTextColumnFilter',
      },
    ]
  }, [])

  const csvFields: CSVField[] = useMemo(
    () => [
      { label: 'Team ID', value: 'id' },
      { label: 'Team Name', value: 'name' },
      {
        label: 'Initial Family Caregiver',
        value: (data: TeamInfo) => `${data.ownerFirstname} ${data.ownerLastname}`,
      },
      {
        label: 'Team Members',
        value: (data: TeamInfo) =>
          data.members.map((member) => `${member.firstName} ${member.lastName}`).join(', '),
      },
      {
        label: 'Creation Date',
        value: (data: TeamInfo) => formatDate(data.createdAt),
      },
      { label: 'Promo Code', value: 'accessCodeCode' },
    ],
    [],
  )

  return { columnDefs, csvFields }
}
